/**
 * @ngdoc service
 * @name checkins.factory:emailContacts
 *
 * @description
 *
 */
import contactBulkMessageModalCreator from '../../../../modules/messages/helpers/contact-bulk-message-modal-creator';

angular
    .module('festzelt-os.contacts')
    .factory('emailContacts', [
        '$injector',
        ($injector) => {
            return {
                key: 'email-contacts',
                title: 'Send Email',
                level: 'selected',
                action({}, store) {
                    contactBulkMessageModalCreator($injector, store);
                }
            }
        }
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/list-view/email-contacts.js